import { AppLayout, Banner, ScrollableContainerWithFooter } from '@components';
import { UIHelper } from '@helpers';
import { useResponsive } from '@hooks';
import { CUSTOM_BREAKPOINT } from '@types';

import { LoginForm } from './loginForm';
import { LoginSkeleton } from './loginSkeleton';

export const LoginScreenDesktop = ({ isLoading }: { isLoading: boolean }) => {
	const { windowWidth } = useResponsive();

	if (isLoading) {
		return <LoginSkeleton />;
	}

	return (
		<AppLayout styles={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
			<Banner />

			<ScrollableContainerWithFooter>
				<LoginForm
					styles={{
						overflowY: 'auto',
						flex: 1,
						gap: UIHelper.rem(64),
						padding: windowWidth > CUSTOM_BREAKPOINT ? UIHelper.rem(0, 120, 40) : UIHelper.rem(0, 24, 40),
						maxWidth: windowWidth > CUSTOM_BREAKPOINT ? UIHelper.rem(700) : UIHelper.rem(508),
					}}
				/>
			</ScrollableContainerWithFooter>
		</AppLayout>
	);
};
